import { browseStoreName } from '../../components/Shared/Constants/Browse/BrowseConstants';
import {
  defaultBrowseCriteria,
  defaultSearchCriteria,
} from '../../components/Shared/Enum/BrowseParametersEnum';

const initialState = {
  currentUrl: '',
  searchCriteria: defaultSearchCriteria,
  browseCriteria: defaultBrowseCriteria,
  currentLocation: {},
  hasInitialized: false,
  shouldRandomizeListings: false,
};
const reducerName = browseStoreName;

const browseReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SetCurrentUrl'.concat(reducerName):
      return {
        ...state,
        currentUrl: action.payload,
      };
    case 'SetSearchCriteria'.concat(reducerName):
      return {
        ...state,
        searchCriteria: {
          ...state.searchCriteria,
          ...action.payload,
        },
        hasInitialized: true,
      };
    case 'SetBrowseCriteria'.concat(reducerName):
      return {
        ...state,
        browseCriteria: {
          ...state.browseCriteria,
          ...action.payload,
        },
        hasInitialized: true,
      };
    case 'SetStoreLocation'.concat(reducerName):
      return {
        ...state,
        currentLocation: action.payload,
      };
    case 'SetIsAlertBannerOpen'.concat(reducerName):
      return {
        ...state,
        isAlertBannerOpen: action.payload,
      };
    case 'SetShouldRandomizeListings'.concat(reducerName):
      return {
        ...state,
        shouldRandomizeListings: action.payload,
      };
    default:
      return state;
  }
};

export default browseReducer;
